module.exports = __webpack_public_path__ + "ed8ecfda7bb2897001741805ac4898e4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/slack-info/slack-info.html
// module id = 1958
// module chunks = 0